import { merge } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { ACTION_TYPES } from '../../constants';
import { BASE_BIG_QUERY_PARAMS } from '../constants';

const CLICK_ACTION_PAYLOAD = {
    action: {
        type: ACTION_TYPES.CLICK,
    },
};

const HOVER_ACTION_PAYLOAD = {
    action: {
        type: ACTION_TYPES.HOVER,
    },
};

/**
 * Builds a click event constructor.
 *
 * @param {string} type - The big query event type
 * @returns {Function}
 */
export const buildClickEvent = (type) => buildBaseEvent(type, CLICK_ACTION_PAYLOAD);

/**
 * Builds a hover event constructor.
 *
 * @param {string} type - The big query event type
 * @returns {Function}
 */
export const buildHoverEvent = (type) => buildBaseEvent(type, HOVER_ACTION_PAYLOAD);

/**
 * Builds a base big query event constructor.
 *
 * @param {string} type - The big query event type
 * @param {Object} baseParams - The big query event parameters
 * @returns {Function} Builder for enriched big query event
 */
export const buildBaseEvent =
    (type, baseParams = {}) =>
    ({ item, layoutSource, pageElement, ...restParams } = {}) =>
        merge(
            { type },
            BASE_BIG_QUERY_PARAMS,
            baseParams,
            buildPagePayload({ pageElement }),
            buildNotificationPayload({ item, layoutSource }),
            restParams
        );

/**
 * Builds a page payload.
 *
 * @returns {Object}
 **/
const buildPagePayload = ({ pageElement }) => {
    const { pageCtxId } = getContext();

    return {
        page: {
            ctx_id: pageCtxId,
            element: pageElement,
        },
    };
};

/**
 * Builds a notification payload.
 *
 * @param {Object} config
 * @param {Object} config.item - The interacted list item.
 * @param {string} config.layoutSource - The item origin layout source (drawer | toast)
 * @returns {Object}
 **/
const buildNotificationPayload = ({ item, layoutSource }) => {
    if (!item) {
        return {};
    }

    return {
        notification: {
            id: item.id,
            type: item.subType,
            source: layoutSource,
        },
    };
};
